import { render } from "./Side.vue?vue&type=template&id=23306266"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layouts/Side.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23306266"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23306266', __exports__)) {
    api.reload('23306266', __exports__)
  }
  
  module.hot.accept("./Side.vue?vue&type=template&id=23306266", () => {
    api.rerender('23306266', render)
  })

}


export default __exports__